import type { Product as ProductType } from '@virginexperiencedays/products';

import { Products } from './Product';
import { TextProducts } from './TextProducts';

export type ProductEmbedType = ProductType & { title_override?: string };
type Props = {
  products: ProductEmbedType[];
  variant: string;
};

export const ProductEmbed = ({ products, variant }: Props) => {
  const isSingle = products.length === 1;
  const filteredProducts = products.filter(
    (product) => product.title && product.status === 'active'
  );
  return variant === 'Text' ? (
    <TextProducts filteredProducts={filteredProducts} />
  ) : (
    <Products isSingle={isSingle} filteredProducts={filteredProducts} />
  );
};
